/* PokeFrame theme */
(function(){
  'use strict';
  const T = window.theme || {};

  /* ===== Reveal-on-scroll ===== */
  function initReveal(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in')); return;
    }
    const io = new IntersectionObserver((ents)=>{
      ents.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:.12});
    document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
  }

  /* ===== Hero video carousel ===== */
  function initHero(){
    const vids = [...document.querySelectorAll('#heroVideos video')];
    const dots = [...document.querySelectorAll('#heroDots button')];
    if(!vids.length) return;
    let cur = 0, timer = null;
    const SLIDE_MS = 5000;
    const show = (i)=>{
      cur = (i + vids.length) % vids.length;
      vids.forEach((v,idx)=>{
        const on = idx===cur;
        v.classList.toggle('active', on);
        if(on){ v.currentTime = 0; v.play().catch(()=>{}); }
        else { v.pause(); }
      });
      dots.forEach((d,idx)=>d.classList.toggle('active', idx===cur));
    };
    const arm = ()=>{ clearTimeout(timer); timer = setTimeout(()=>{ show(cur + 1); arm(); }, SLIDE_MS); };
    dots.forEach((d,i)=> d.addEventListener('click', ()=>{ show(i); arm(); }));
    vids[0].play().catch(()=>{});
    arm();
    vids.forEach(v=> v.addEventListener('ended', ()=>{ show(cur + 1); arm(); }));
    const dotsEl = document.getElementById('heroDots');
    const hero = document.querySelector('.hero');
    if(dotsEl && hero){
      const onScroll = ()=>{
        const past = window.scrollY > hero.offsetHeight - window.innerHeight + 40;
        dotsEl.classList.toggle('hidden', past);
      };
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }
  }

  /* ===== Variant picker on product page ===== */
  function initVariantPicker(){
    const form = document.getElementById('pfAddForm');
    const data = window.pfProduct;
    if(!form || !data) return;
    const opts = data.optionNames || [];
    const variantInput = document.getElementById('pfVariantId');
    const priceEl = document.getElementById('pfPrice');
    const btnPriceEl = document.getElementById('pfBtnPrice');
    const mainImg = document.getElementById('mainImg');
    const addBtn = document.getElementById('pfAddBtn');

    // Current selection from active swatches / select values
    function readSelection(){
      const selected = [];
      opts.forEach(name=>{
        const swatchBox = form.querySelector(`.swatches[data-pfopt="${cssEscape(name)}"]`);
        if(swatchBox){
          const active = swatchBox.querySelector('button.active') || swatchBox.querySelector('button');
          selected.push(active ? active.dataset.value : '');
          return;
        }
        const sel = form.querySelector(`select[data-pfopt="${cssEscape(name)}"]`);
        if(sel){ selected.push(sel.value); return; }
        selected.push('');
      });
      return selected;
    }
    function cssEscape(s){ return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g,'\\"'); }

    function findVariant(selected){
      return (data.variants||[]).find(v=>{
        return (v.options||[]).every((o,i)=> (selected[i]||'') === o);
      });
    }

    function update(){
      let v;
      const hasPicker = form.querySelector('.swatches[data-pfopt], select[data-pfopt]');
      if(data.hasOnlyDefault || !hasPicker){
        // single-variant product (or no rendered picker) — use first available variant
        v = (data.variants||[]).find(x=>x.available) || (data.variants||[])[0];
      } else {
        v = findVariant(readSelection());
      }
      if(v){
        variantInput.value = v.id;
        const fmt = v.priceFmt || formatMoney(v.price);
        if(priceEl) priceEl.firstChild.nodeValue = fmt + ' ';
        if(btnPriceEl) btnPriceEl.textContent = fmt;
        addBtn.disabled = !v.available;
        addBtn.style.opacity = v.available ? 1 : .55;
        if(v.featured && mainImg){
          mainImg.src = v.featured.replace(/\?.+$/, '') + '?width=1200';
          const firstThumb = document.querySelector('#thumbs button');
          if(firstThumb && firstThumb.querySelector('img')){
            firstThumb.querySelector('img').src = v.featured.replace(/\?.+$/, '') + '?width=200';
          }
        }
      } else {
        addBtn.disabled = true; addBtn.style.opacity = .55;
        if(btnPriceEl) btnPriceEl.textContent = 'Unavailable';
      }
    }

    form.querySelectorAll('.swatches').forEach(box=>{
      box.addEventListener('click', e=>{
        const b = e.target.closest('button[data-value]');
        if(!b) return;
        box.querySelectorAll('button').forEach(x=> x.classList.remove('active'));
        b.classList.add('active');
        update();
      });
    });
    form.querySelectorAll('select[data-pfopt]').forEach(s=> s.addEventListener('change', update));

    update();
  }

  /* ===== Thumbs ===== */
  function initThumbs(){
    const thumbs = document.getElementById('thumbs');
    const main = document.getElementById('mainImg');
    if(!thumbs || !main) return;
    thumbs.addEventListener('click', e=>{
      const b = e.target.closest('button[data-src]');
      if(!b) return;
      thumbs.querySelectorAll('button').forEach(x=> x.classList.remove('active'));
      b.classList.add('active');
      main.style.opacity = 0;
      setTimeout(()=>{ main.src = b.dataset.src; main.style.opacity = 1; }, 120);
    });
  }

  /* ===== Add to cart (Ajax) ===== */
  function initAddForm(){
    const form = document.getElementById('pfAddForm');
    if(!form) return;
    const status = document.getElementById('pfStatus');
    const addBtn = document.getElementById('pfAddBtn');
    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      const id = document.getElementById('pfVariantId').value;
      if(!id) return;
      addBtn.disabled = true; const orig = addBtn.innerHTML;
      addBtn.innerHTML = 'Adding…';
      status.className = 'pdp-status'; status.textContent = '';
      const qty = Number(document.getElementById('pfQty')?.value || 1) || 1;
      const addonItems = [];
      let freeGiftSelected = false;
      document.querySelectorAll('#pfAddons .pdp-addon-cb:checked').forEach(cb=>{
        const vid = cb.closest('.pdp-addon')?.dataset.variantId;
        if(!vid) return;
        // Free gift is display-only: record as a cart attribute, not a line item
        if(Number(vid) === FREE_GIFT_VARIANT){ freeGiftSelected = true; return; }
        addonItems.push({ id: Number(vid), quantity: 1 });
      });
      try{
        const res = await fetch(T.cartAddUrl || '/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[{ id: Number(id), quantity: qty }, ...addonItems] })
        });
        if(!res.ok){ const err = await res.json().catch(()=>({})); throw new Error(err.description || 'Could not add to cart.'); }
        const cartData = await res.json().catch(()=>null);
        if(freeGiftSelected){
          try{
            await fetch('/cart/update.js', {
              method:'POST',
              headers:{'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({ attributes: { 'Free Gift': 'Mystery Pack (comped with code)' } })
            });
          }catch(e){}
        }
        await refreshCartCount();
        // Meta Pixel AddToCart event
        try {
          if (window.fbq && cartData) {
            const item = (cartData.items && cartData.items[0]) || cartData;
            const itemPrice = ((item.final_price ?? item.price ?? 0) / 100);
            const total = itemPrice * (item.quantity || qty);
            window.fbq('track', 'AddToCart', {
              content_ids: [String(item.product_id || item.id || id)],
              content_name: item.product_title || item.title || '',
              content_type: 'product',
              contents: [{ id: String(item.variant_id || item.id || id), quantity: item.quantity || qty, item_price: itemPrice }],
              value: total,
              currency: 'USD'
            });
          }
        } catch (e) {}
        status.className = 'pdp-status ok';
        status.innerHTML = 'Added to cart. <a href="'+ (T.cartUrl||'/cart') +'" style="text-decoration:underline">View cart →</a>';
      } catch(err){
        status.className = 'pdp-status err';
        status.textContent = err.message || 'Something went wrong.';
      } finally {
        addBtn.disabled = false; addBtn.innerHTML = orig;
      }
    });
  }

  async function refreshCartCount(){
    try{
      const res = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
      const data = await res.json();
      const el = document.getElementById('pfCartCount');
      if(el){ el.textContent = '(' + data.item_count + ')'; el.dataset.count = data.item_count; }
    } catch(e){}
  }

  /* ===== Free gift: only 1 per order, regardless of how many products ===== */
  var FREE_GIFT_VARIANT = 56706986541222;
  async function enforceFreeGiftCap(){
    try{
      const cart = await (await fetch('/cart.js', {headers:{'Accept':'application/json'}})).json();
      const line = (cart.items || []).find(i => i.variant_id === FREE_GIFT_VARIANT || i.id === FREE_GIFT_VARIANT);
      if(line && line.quantity > 1){
        await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: FREE_GIFT_VARIANT, quantity: 1 })
        });
      }
    } catch(e){}
  }

  /* ===== Cart page +/− & remove ===== */
  function initCartPage(){
    const form = document.getElementById('pfCartForm');
    if(!form) return;
    enforceFreeGiftCap();
    async function changeLine(line, qty){
      const res = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ line, quantity: qty })
      });
      if(res.ok){ window.location.reload(); }
    }
    form.querySelectorAll('.cart-item').forEach(item=>{
      const line = Number(item.dataset.line);
      const qtyInput = item.querySelector('input[type="number"]');
      item.querySelector('[data-act="inc"]')?.addEventListener('click', ()=> changeLine(line, Number(qtyInput.value)+1));
      item.querySelector('[data-act="dec"]')?.addEventListener('click', ()=> changeLine(line, Math.max(0, Number(qtyInput.value)-1)));
      item.querySelector('[data-act="remove"]')?.addEventListener('click', ()=> changeLine(line, 0));
    });
  }

  function formatMoney(cents){
    const n = (Number(cents)/100);
    return '$' + n.toFixed(2);
  }

  /* ===== Volume tier selector (product page) ===== */
  function initVolTiers(){
    const wrap = document.getElementById('pfVolTiers');
    if(!wrap) return;
    const qtyInput = document.getElementById('pfQty');
    const btnPriceEl = document.getElementById('pfBtnPrice');
    const tiers = [...wrap.querySelectorAll('.vol-tier')];

    function pickTier(t){
      tiers.forEach(x=>{ x.classList.remove('active'); x.setAttribute('aria-checked','false'); });
      t.classList.add('active');
      t.setAttribute('aria-checked','true');
      if(qtyInput) qtyInput.value = t.dataset.qty;
      // mirror this tier's price into the add-to-cart button
      const priceText = t.querySelector('.vt-price')?.firstChild?.textContent?.trim();
      if(btnPriceEl && priceText) btnPriceEl.textContent = priceText;
    }

    tiers.forEach(t=> t.addEventListener('click', ()=> pickTier(t)));
  }

  /* ===== Top banner countdown (persists across pages via localStorage) ===== */
  function initTopTimer(){
    const el = document.getElementById('pfTopTimer');
    if(!el) return;
    const totalMin = Number(el.dataset.minutes || 30);
    const totalMs = totalMin * 60 * 1000;
    const KEY = 'pf_top_timer_end_v1';

    function getExpiry(){
      let exp = 0;
      try { exp = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch(e){}
      if(!exp || exp <= Date.now()){
        exp = Date.now() + totalMs;
        try { localStorage.setItem(KEY, String(exp)); } catch(e){}
      }
      return exp;
    }

    let expires = getExpiry();
    const tick = ()=>{
      let secs = Math.max(0, Math.floor((expires - Date.now()) / 1000));
      if(secs <= 0){
        // start a fresh cycle so the sale always feels live
        expires = Date.now() + totalMs;
        try { localStorage.setItem(KEY, String(expires)); } catch(e){}
        secs = Math.floor(totalMs / 1000);
      }
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      const s = secs % 60;
      const pad = n => (n < 10 ? '0' : '') + n;
      el.textContent = (totalMin >= 60)
        ? (h + ':' + pad(m) + ':' + pad(s))
        : (pad(m) + ':' + pad(s));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ===== Cart urgency countdown (5-min, resets on cart visit) ===== */
  function initCartTimer(){
    const el = document.getElementById('pfCartTimer');
    if(!el) return;
    let secs = 5 * 60;
    const tick = ()=>{
      if(secs <= 0){ el.textContent = '00:00'; el.classList.add('expired'); return; }
      const m = Math.floor(secs / 60), s = secs % 60;
      el.textContent = (m<10?'0':'') + m + ':' + (s<10?'0':'') + s;
      secs--;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ===== UGC video carousel (infinite loop) ===== */
  function initUGC(){
    const wraps = [...document.querySelectorAll('.ugc-carousel')];
    if(!wraps.length) return;
    wraps.forEach(wrap => initOneUGC(wrap));
  }

  function initOneUGC(wrap){
    const track = wrap.querySelector('.ugc-track');
    const cards = [...wrap.querySelectorAll('.ugc-card')];
    const dots = [...wrap.querySelectorAll('.ugc-dots button')];
    const prev = wrap.querySelector('.ugc-arrow.prev');
    const next = wrap.querySelector('.ugc-arrow.next');
    const viewport = wrap.querySelector('.ugc-viewport');
    if(!track || cards.length === 0) return;

    const PADDING = Number(wrap.dataset.padding || 3); // clones on each side
    const total = cards.length;          // real + 2*PADDING
    const real = total - 2 * PADDING;    // real video count
    let pos = PADDING;                   // start at first real card
    let busy = false;

    const apply = (instant)=>{
      const cardW = cards[0].offsetWidth;
      const wrapW = viewport.offsetWidth;
      const gap = 18;
      const offset = pos * (cardW + gap) - (wrapW - cardW) / 2;
      if(instant){
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-offset) + 'px)';
        track.offsetHeight; // force reflow
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(' + (-offset) + 'px)';
      }
      cards.forEach((c,i)=> c.classList.toggle('current', i === pos));
      const realIdx = ((pos - PADDING) % real + real) % real;
      dots.forEach((d,i)=> d.classList.toggle('active', i === realIdx));
      cards.forEach((c,i)=>{
        const v = c.querySelector('video');
        if(!v) return;
        if(i === pos){ v.play().catch(()=>{}); } else { v.pause(); v.currentTime = 0; }
      });
    };

    const goTo = (newPos, instant)=>{
      if(busy && !instant) return;
      pos = newPos;
      if(instant){
        apply(true);
        return;
      }
      busy = true;
      apply(false);
      const after = ()=>{
        track.removeEventListener('transitionend', after);
        // snap back if landed on any clone position
        if(pos < PADDING){ pos += real; apply(true); }
        else if(pos >= real + PADDING){ pos -= real; apply(true); }
        busy = false;
      };
      track.addEventListener('transitionend', after, {once:true});
      // safety fallback if transitionend doesn't fire
      setTimeout(()=>{ if(busy){ after(); } }, 700);
    };

    if(prev) prev.addEventListener('click', ()=> goTo(pos - 1));
    if(next) next.addEventListener('click', ()=> goTo(pos + 1));
    dots.forEach((d,i)=> d.addEventListener('click', ()=> goTo(i + PADDING)));
    cards.forEach((c,i)=> c.addEventListener('click', ()=>{
      if(i === pos){
        const v = c.querySelector('video');
        if(v){ v.muted = !v.muted; }
      } else {
        goTo(i);
      }
    }));
    window.addEventListener('resize', ()=> apply(true), {passive:true});
    apply(true);
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    initReveal();
    initTopTimer();
    initHero();
    initUGC();
    initVariantPicker();
    initVolTiers();
    initThumbs();
    initAddForm();
    document.querySelectorAll('#pfAddons .pdp-addon-cb').forEach(cb=>{
      cb.addEventListener('change', ()=>{
        cb.closest('.pdp-addon')?.classList.toggle('checked', cb.checked);
      });
    });
    initCartPage();
    initCartTimer();
    refreshCartCount();
  });
})();
